module.exports = __webpack_public_path__ + "media/assets/icons/time-forward-white-831022c58e628fd579f1cd454f663e06.svg";